module.exports = __webpack_public_path__ + "img/eztran.2cefec18.png";